import api from "@/plugins/api/EntryPoint";

export default {
  async createDistributionOrderLviv(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-lviv/create-distribution-order-lviv",
      params,
      callBackFn
    );
  },
  async createDistributionToOrderLviv(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-lviv/create-distribution-to-order-lviv",
      params,
      callBackFn
    );
  },
  async getLvivAccountDistributionDebt(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-lviv/get-lviv-account-distribution-debt",
      params,
      callBackFn
    );
  },
};
